import React from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography, createStyles, makeStyles } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'

interface IStepCardProps {
  children: React.ReactNode
  title: string
}

const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      width: '100%',
      paddingTop: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        width: '776px',
      },
    },
  })
)

const StepCard = ({ children, title }: IStepCardProps) => {
  const { isMobile } = useBreakpointContext()
  const cardStyles = useStyles()
  return (
    <Box width='100%' display='flex' justifyContent='center'>
      <Box className={cardStyles.container}>
        <Card transparent={isMobile}>
          <Typography variant='h3'>{title}</Typography>
          <Box paddingTop='20px'>{children}</Box>
        </Card>
      </Box>
    </Box>
  )
}

export default StepCard
